import React from 'react';
import { classNames } from '@tpr/core';
import { Toolbar } from './card';
import styles from './content.module.scss';
export var Loading = function () { return React.createElement("div", { className: styles.loading }); };
export var Content = function (_a) {
    var _b;
    var children = _a.children, title = _a.title, _c = _a.loading, loading = _c === void 0 ? false : _c, Breadcrumbs = _a.breadcrumbs, subtitle = _a.subtitle, sectionTitle = _a.sectionTitle;
    return (React.createElement("div", { className: classNames([
            (_b = {}, _b[styles.noTopPadding] = typeof Breadcrumbs === 'function', _b),
            styles.content,
        ]) },
        loading && React.createElement(Loading, null),
        Breadcrumbs && React.createElement(Breadcrumbs, null),
        title && (React.createElement(Toolbar, { title: title, subtitle: subtitle, sectionTitle: sectionTitle })),
        children));
};
//# sourceMappingURL=content.js.map